/**
 * External Dependencies
 */
import 'jquery';

/**
 * Local Dependencies
 */
import './header.js';
import './lead-generator.js';

$(() => {});

window.onload = function () {
  lax.init();

  // Add a driver that we use to control our animations
  lax.addDriver(
    'scrollY',
    function () {
      return window.scrollY;
    },
    {}
  );

  // Add animation bindings to elements
  lax.addElements('.lax-fadein', {
    scrollY: {
      opacity: [
        ['elInY+150', 'elCenterY'],
        {
          500: [1, 1],
          900: [0, 1],
        },
      ],
      translateY: [
        ['elInY', 'elOutY'],
        {
          500: [0, 0],
          900: [100, 20],
        },
      ],
    },
  });

  // Add animation bindings to elements
  lax.addElements('.lax-parallax', {
    scrollY: {
      translateY: [
        ['elInY', 'elOutY'],
        {
          767: [0, -40],
          768: [-100, 100],
        },
      ],
    },
  });

  lax.addElements('.lax-second-text-and-image', {
    scrollY: {
      translateY: [
        ['elInY', 'elOutY'],
        {
          640: [-70, -70],
          900: [-90, 40],
          1024: [-130, 40],
        },
      ],
    },
  });

  // Add animation bindings to elements
  lax.addElements('.lax-scrollOut', {
    scrollY: {
      opacity: [
        ['elCenterY+200', 'elOutY-200'],
        {
          500: [1, 1],
          900: [1, 0],
        },
      ],
    },
  });

  // Add animation bindings to elements
  lax.addElements('.lax-graphic-animate', {
    scrollY: {
      translateY: [
        ['elInY', 'elOutY'],
        {
          500: [0, 0],
          900: [0, 600],
        },
      ],
    },
  });

  // Add animation bindings to elements
  lax.addElements('.lax-footer-sidemove', {
    scrollY: {
      translateX: [
        ['elInY', 'elCenterY-800'],
        {
          500: [0, 0],
          900: [-500, 500],
        },
      ],
    },
  });
  // On click on #coverImageOverVideo remove the block and play video from iframe #video
  $('#coverImageOverVideo').on('click', function () {
    var iframe = document.querySelector('iframe');


    $(this).remove();

  });
};
